import {
  ProcessOfferStatusOptionsTranslation,
  processOfferStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  realizationTranslation,
  RealizationTranslation,
} from '@/assets/locales/views/calendar/realization.translation.pl.ts';
import { WeekDaysEnum } from '@/views/calendar/components/table/body/model/WeekDays.enum.ts';
import { CalendarFormModel } from '@/views/calendar/components/table/model/CalendarForm.model.ts';

export type CalendarTranslation = {
  column: {
    hiddenByFilter: string;
    item: {
      tooltip: {
        generateOfferFile: string;
        previewPdf: string;
      };
    };
    noEvents: string;
  };
  drawer: {
    openInClassicView: string;
  };
  legend: ProcessOfferStatusOptionsTranslation & {
    clear: string;
    ownerOnly: string;
    title: string;
  };
  list: {
    columns: {
      author: string;
      customer: string;
      event: string;
      guests: string;
      status: string;
      time: string;
    };
    openPreview: string;
    stats: {
      events: string;
      guests: string;
    };
    today: string;
  };
  realization: RealizationTranslation;
  table: {
    filters: Record<keyof CalendarFormModel, string> & {
      button: {
        generateFileWeek: string;
        submit: string;
        thisWeek: string;
      };
    };
    tooltip: {
      generateFileDay: string;
      generateFileOffer: string;
    };
  };
  weekday: Record<keyof typeof WeekDaysEnum, string>;
};

export const calendarTranslation: CalendarTranslation = {
  column: {
    hiddenByFilter: 'Ukryte przez filtr',
    item: {
      tooltip: {
        generateOfferFile: 'Pobierz realizację',
        previewPdf: 'Podgląd PDF',
      },
    },
    noEvents: 'Brak wydarzeń',
  },
  drawer: {
    openInClassicView: 'Otwórz w widoku klasycznym',
  },
  legend: {
    ...processOfferStatusOptionsTranslation,
    clear: 'wyczyść',
    ownerOnly: 'tylko Twoje procesy',
    title: 'Legenda',
  },
  list: {
    columns: {
      author: 'Autor oferty',
      customer: 'Klient',
      event: 'Wydarzenie',
      guests: 'Osób',
      status: 'Status',
      time: 'Godziny',
    },
    openPreview: 'Podgląd oferty: {{name}}',
    stats: {
      events: 'Wydarzenia',
      guests: 'Goście',
    },
    today: 'dziś',
  },
  realization: realizationTranslation,
  table: {
    filters: {
      button: {
        generateFileWeek: 'Pobierz plan tygodnia',
        submit: 'Szukaj',
        thisWeek: 'Aktualny tydzień',
      },
      calendarIds: 'Kalendarze',
      from: 'Od',
      to: 'Do',
      userId: 'Kalendarz użytkownika',
      week: 'Tydzień',
    },
    tooltip: {
      generateFileDay: 'Pobierz plan dnia',
      generateFileOffer: 'Pobierz realizację',
    },
  },
  weekday: {
    FRIDAY: 'Piątek',
    MONDAY: 'Poniedziałek',
    SATURDAY: 'Sobota',
    SUNDAY: 'Niedziela',
    THURSDAY: 'Czwartek',
    TUESDAY: 'Wtorek',
    WEDNESDAY: 'Środa',
  },
};
